// extracted by mini-css-extract-plugin
module.exports = {"root":"fc1HcA","marketColumn":"BAWIxd"};